import styles from "./registerbutton.module.css";

interface Props {
  isInMenu?: boolean;
  isLoginPage?: boolean;
  isRegisterPage?: boolean;
  HandleOnClick?: () => void;
}

export default function RegisterButton({ isInMenu, isLoginPage, isRegisterPage, HandleOnClick }: Props) {
  return (
    <>
      <button type="button" className={`${styles.registerButton} ${isInMenu ? styles.menuStyle : ''} ${isLoginPage && styles.loginPage} ${isRegisterPage && styles.registerPage}`} onClick={HandleOnClick}>Register</button>
    </>
  );
}
